<template>
  <div
    class="app app-header-fixed app-aside-fixed"
    :class="{ ['_hide-scroll']: scrollIsHidden }"
  >
    <Header data-testid="header" />
    <horizontal-nav-menu v-if="isLogged && account" data-testid="horizontal-nav-menu" />
    <ErrorDialog
      v-if="isLogged && account"
      ref="errorDialog"
      id="errorDialog"
      data-testid="error-dialog"
    />

    <!-- Example for modal (commented out in your code) -->
    <!--
    <BModal
      v-if="trainHospitalActive"
      id="modal"
      v-model="trainHospitalActive"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      data-testid="training-hospital-modal"
    >
      <div class="text-start p-3"> 
        <div class="mt-1" :class="$style.text">
          You are still in Training Hospital...
        </div>
        <div class="mt-3" :class="$style.modalText">
          <div :class="$style.padding">
            To access live hospitals as a manager <b>you need to leave Training <br />
            Hospital environment on your mobile device.</b>
          </div>
          <div :class="$style.padding">
            Please tap <b>blue button</b> on mobile screen to leave Training Hospital.
          </div>
          <div :class="$style.padding">
            To get further instructions contact main manager of your department.
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <b-button
            size="md"
            class="mt-2"
            :class="$style.btn"
            @click="authLogout"
            data-testid="understood-btn"
          >
            Understood
          </b-button>
        </div>
      </div>
    </BModal>
    -->

    <!-- Loading overlay -->
    <!-- <b-overlay v-else-if="initLoading" :show="true" rounded="sm" data-testid="loading-overlay" /> -->

    <!-- Main content -->
    <div>
      <router-view :key="$route.fullPath" data-testid="router-view"></router-view>
    </div>

    <JobsApproval v-if="jobsForApproval.length" data-testid="jobs-approval" />
    <Footer data-testid="footer" />

    <!-- Idle detector -->
    <v-idle
      @idle="onidle"
      :loop="true"
      :events="['mousemove', 'keypress', 'mousedown', 'touchmove','scroll']"
      :wait="0"
      :duration="900"
      data-testid="idle-detector"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Header from './redesign/components/Header.vue';
import Footer from './redesign/components/Footer.vue';
import JobsApproval from './redesign/components/JobsApproval.vue';
import HorizontalNavMenu from './components/horizontal-nav-menu/HorizontalNavMenu.vue';
import ErrorDialog from './redesign/components/ErrorDialog.vue';
import { unSubscribeNotifications } from './firebaseApi';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    JobsApproval,
    HorizontalNavMenu,
    ErrorDialog,
  },
  methods: {
    ...mapActions({
      authLogout: 'authLogout',
      setNotifications: 'messenger/setNotifications',
    }),
    onidle() {
      const token = window.localStorage.getItem('token');
      if (token) {
        unSubscribeNotifications(this.db, this.account?.id);
        this.isOpenPopover = false;
        this.setNotifications({});
        this.authLogout();
        this.$router.push('/sign-in').catch((error) => {
          console.log('error', error);
        });
      }
    },
  },
  computed: {
    ...mapState([
      'initLoading',
      'jobsForApproval',
      'trainHospitalActive',
      'scrollIsHidden',
      'isLogged',
    ]),
    ...mapGetters({
      db: 'firebaseDb',
      account: 'account',
    }),
  },
};
</script>


<style lang="scss">
@import "ag-grid-community/styles/ag-grid.css";
@import "ag-grid-community/styles/ag-theme-quartz.css";
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300&display=swap');

$black : #000;

body{
	overflow: hidden;
}

.app{
	display: flex;
	position: absolute;
	width: 100%;
	height: 100vh;
	flex-direction: column;
	// overflow-y: scroll;
	&>*:nth-of-type(n+2){
		flex: 0 0 auto;
	}
	&>*:nth-of-type(2){
		flex: 1 0 auto;
	}

	&>*:nth-of-type(2){
		padding-bottom: 20px;
	}

	&._hide-scroll{
		position: fixed;
	}
}

.loader {
  margin-top: 50px;
}

.inline-loader {
  display: inline-block;
  margin-left: 10px;
}
.v-toaster {
  top: 70px;
}

/* width */
::-webkit-scrollbar {
	width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
	background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #96a0af;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	background: #555;
}

.tooltip >.tooltip-inner {
  background: #373737 !important;
  color: #ffff !important;
  border-radius: 0px !important;
  padding: 5px 10px 4px !important;
}

.simple-modal{
	padding: 1rem;
	&__header{
		font-weight: 300;
		font-size: 24px;
		line-height: 30px;
		color: $black;
		margin-bottom: 24px;
	}
	&__body{
		font-size: 16px;
		line-height: 20px;
		& > *{
			margin-bottom: 16px;
			line-height: 20px;
		}
		& > *:last-of-type{
			margin-bottom: 36px;
			line-height: 20px;
		}
	}
	&__buttons{
		display: flex;
		justify-content: flex-end;

		&>button:nth-of-type(2n){
			margin-left: 24px;
		}
	}
}

.modalTable{
	&__content{
		font-size: 18px;
	}

	&__header{
		font-weight: 300;
		font-size: 24px;
	}

	&__button{
		padding-right: 30px;
		padding-left: 30px;
		&:nth-of-type(1){
			margin-right: 24px;
		}
	}

	.cancelButton,
	.cancelButton:hover{
		background-color: transparent;
		border: 1px solid #BBC2C7;
		color:white;
		background-color: #F54E4E;
	}
}

.time-track-modal {
	padding: 25px 30px;
	color: $black;

	.modal-body {
		padding: 0;
	}

	.title {
		font-weight: 300;
		font-size: 24px;
		line-height: 30px;
		margin-bottom: 25px;
	}

	.description {
		font-size: 16px;
		line-height: 20px;
		min-height: 50px;
	}

	.btn {
		height: 40px;
		min-width: 135px;
		color: #373737;
		border-radius: 3px;
		border: 1px solid #D5E0E8;
		background-color: transparent;
		font-size: 15px;
		line-height: 19px;

		&:last-child {
			margin-left: 25px;
		}

		&:focus {
			box-shadow: none;
		}
	}

	.danger-btn, .success-btn {
		color: #ffffff;
		border: none;

		&:hover {
			color: #ffffff;
		}
	}

	.danger-btn {
		background-color: #F54E4E;
	}

	.success-btn {
		background-color: #6FDAA5;
	}
}

.v-idle {
		display: none;
}
</style>

<style lang="scss" module>

	.padding {
		padding-bottom: 20px;
	}
	.text {
		font-family: Source Sans Pro;
		font-style: normal;
		font-size: 24px;
		line-height: 30px;
		color: #373737;
		padding-bottom: 30px;
	}
	.modalText {
		font-family: Source Sans Pro;
		font-style: normal;
		font-weight: normal;
		font-size: 15px;
		line-height: 18px;
		color: #373737;
	}
</style>
